function Preloader() {
  return (
    <div className="preloader">
      <div className="preloader-content">
        <img 
            src={process.env.PUBLIC_URL + "/img/tss.png"} 
            alt="TSS Loading" 
            className="preloader-logo" 
        />
        <div className="loading-bar"></div>
      </div>
    </div>
  );
}
export default Preloader;
